import Utils from './Utils';
import { workflowHasMessageShowEnd } from './workflowMessageShowUtils';

/**
 * @param {import('../models/Workflow').default} workflow
 * @returns {string|null}
 */
export function getLastCompletedBrickType(workflow) {
    const last_id = workflow?.context?.__last_completed_brick__;
    if (!last_id)
        return null;
    const brick = (workflow?.bricks || []).find((b) => String(b.id) === String(last_id));
    return brick?.type ?? null;
}

/**
 * @param {import('../models/Workflow').default} workflow
 * @returns {boolean}
 */
export function shouldSkipGenericCompletion(workflow) {
    const last_type = getLastCompletedBrickType(workflow);
    if (last_type === 'redirect')
        return true;
    if (last_type === 'message.show' || workflowHasMessageShowEnd(workflow))
        return true;
    return false;
}

/**
 * @param {import('../models/Workflow').default} workflow
 * @param {string} lang
 * @param {(key: string) => string} t
 * @returns {{ mainHtml: string, extraMessages: string[] }}
 */
export function getWorkflowCompletionContent(workflow, lang, t) {
    const extra_messages = (workflow.getMessages() || []).map((m) => String(m));
    const configured = String(
        Utils.localized_or_fallback(workflow.completion_message, lang, '') || ''
    ).trim();
    let main_html = configured;
    if (!main_html && extra_messages.length === 0)
        main_html = t('workflows.completion_default');

    return {
        mainHtml: main_html,
        extraMessages: extra_messages,
    };
}
